import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'nta-logo',
	imports: [RouterModule],
	templateUrl: './logo.component.html',
	styleUrls: ['./logo.component.scss']
})
export class NtaLogoComponent {
	constructor() {}
}
